import { Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';

@Component({
  selector: 'app-about',
  imports: [MatCardModule, MatButtonModule, MatIconModule, MatDividerModule],
  templateUrl: './about.component.html',
  styleUrl: './about.component.scss'
})
export class AboutComponent {
  linkedIn = 'https://www.linkedin.com/in/oleh-rumyk-a13659219/';

  headerText = 'With 23+ years in IT — the last 6+ dedicated to DevOps — I specialise in designing and managing cloud-native infrastructures across AWS, GCP, and Azure using Infrastructure as Code. I am passionate about streamlining developer workflows through automation, CI/CD, and container orchestration, and I enjoy building bridges between development and operations teams.';

  competencies = [
    { data: 'Multi-cloud architecture and management across AWS (30+ services), GCP, and Azure.' },
    { data: 'Infrastructure as Code with Terraform and Ansible across Dev, Staging, and Production environments.' },
    { data: 'Container orchestration with Kubernetes (EKS, GKE, AKS) and Docker.' },
    { data: 'CI/CD pipeline design with GitHub Actions, Jenkins, AWS CodePipeline, and GCP Cloud Build.' },
    { data: 'Monitoring and observability with Datadog, Prometheus, Grafana, New Relic, and AWS CloudWatch.' },
    { data: 'Strong cross-team communication across engineering, QA, and business stakeholders.' }
  ];

  achievements = [
    { data: 'Unified infrastructure management across AWS, GCP, Azure, Terraform Cloud, and MongoDB Cloud from a single workflow.' },
    { data: 'Designed multi-environment infrastructure (Dev / Staging / Beta / Production) optimising cost and resource efficiency.' },
    { data: 'Modernised deployments with Docker and Kubernetes (EKS, ECS, GKE), improving portability and scalability.' },
    { data: 'Delivered end-to-end CI/CD pipelines that reduced deployment lead time and production failure rate.' },
    { data: 'Built an active ML training loop on GCP for free-energy calculation workloads.' }
  ];
}
